/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Time_OutInputs */

const en_orders_time_out = /** @type {(inputs: Orders_Time_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Out`)
};

const es_orders_time_out = /** @type {(inputs: Orders_Time_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de salida`)
};

/**
* | output |
* | --- |
* | "Time Out" |
*
* @param {Orders_Time_OutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_time_out = /** @type {((inputs?: Orders_Time_OutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Time_OutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_time_out(inputs)
	return es_orders_time_out(inputs)
});